<ngx-loading-bar [height]="'4px'" [includeSpinner]="false" color="#0c9488"></ngx-loading-bar>
<router-outlet></router-outlet>